import React, { useEffect } from "react";
import { RouterProvider } from "react-router";
import { router } from "./router";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { StyledEngineProvider } from "@mui/material/styles";
import { useTheme } from "./theme";
import { connectWS, disconnectWs } from "./utils/ws";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/cs";
import { useAuthenticationToken } from "./context/AuthenticationTokenContext";
import { SnackbarProvider } from "./components/Snackbar.jsx";
import { LocationProvider } from "./context/LocationContext";

function LocationAwareApp() {
  const theme = useTheme();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="cs">
        <SnackbarProvider>
          <RouterProvider
            router={router}
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          />
        </SnackbarProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export function App() {
  const [token] = useAuthenticationToken();
  useEffect(() => {
    if (token == null) {
      disconnectWs();
      return;
    }

    connectWS();
  }, [token]);

  return (
    <StyledEngineProvider injectFirst={true}>
      <LocationProvider>
        <LocationAwareApp />
      </LocationProvider>
    </StyledEngineProvider>
  );
}
